module.exports = __webpack_public_path__ + "media/images/expert__kathrin-lehmann-59830289e58ee6369ed1d16810d849ab.png";